import type { MigrationResult } from "@/utils/hooks/useWalletMigration";

import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { AppRoute } from "@/constants/routes";
import { MigrationResults, useWalletMigration } from "@/utils/hooks/useWalletMigration";

import { WalletMigrationModal } from "../WalletMigrationModal/WalletMigrationModal";

export const InitWalletMigration = () => {
  const location = useLocation();

  const { tryWalletMigration, isWalletMigrationFinished } = useWalletMigration();

  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState<MigrationResult | null>(null);

  useEffect(() => {
    if (location.pathname === AppRoute.welcome || location.pathname === "/") {
      return;
    }

    if (!isWalletMigrationFinished) {
      const result = tryWalletMigration();
      setMode(result);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, isWalletMigrationFinished]);

  useEffect(() => {
    if (!mode || mode === MigrationResults.NOTHING) return;

    // NOTE: delay is needed to avoid flashing of the modal
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 500);

    return () => clearTimeout(timer);
  }, [mode]);

  if (!mode || mode === MigrationResults.NOTHING) {
    return null;
  }

  return (
    <WalletMigrationModal
      isOpen={isOpen}
      mode={mode}
      onClose={() => {
        setIsOpen(false);
      }}
    />
  );
};
